import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";
import acc from 'accounting'

export default class UrzadRaportDoplatGrupOgolemTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wszystkieKolumnyEksport: [
                {value: "nrgrupy", label: 'Nr grupy'},
                {value: "nazwaulgi", label: 'Nazwa ulgi'},
                {value: "proculgi", label: 'Procent ulgi'},
                {value: "ilosc", label: 'Ilość'},
                {value: "status", label: 'Status'},
                {value: "wartdoplbrutto", label: 'Wartość dopłaty brutto'},
                {value: "wartdoplnetto", label: 'Wartość dopłaty netto'},
                {value: "wartdoplvat", label: 'Wartość dopłaty vat'},
                {value: "wartbilbrutto", label: 'Wartość biletu brutto'},
                {value: "wartbilnetto", label: 'Wartość biletu netto'},
                {value: "wartbilvat", label: 'Wartość biletu vat'},
            ],
            kolumnyDoExportuDefault: [
                {value: "ilosc", label: 'Ilość'},
                {value: "nazwaulgi", label: 'Nazwa ulgi'},
                {value: "nrgrupy", label: 'Nr grupy'},
                {value: "proculgi", label: 'Procent ulgi'},
                {value: "status", label: 'Status'},
                {value: "wartdoplbrutto", label: 'Wartość dopłaty brutto'},
                {value: "wartdoplnetto", label: 'Wartość dopłaty netto'},
                {value: "wartdoplvat", label: 'Wartość dopłaty vat'},
                {value: "wartbilbrutto", label: 'Wartość biletu brutto'},
                {value: "wartbilnetto", label: 'Wartość biletu netto'},
                {value: "wartbilvat", label: 'Wartość biletu vat'},
            ],
        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops) {
    }


    formatCell(cell,row){

        if(cell === "PODSUMOWANIE DLA WSZYSTKICH PRAWIDŁOWYCH"){
            return <span style={{fontWeight:"bold"}}>&sum; DLA WSZYSTKICH PRAWIDŁOWYCH</span>
        }else{
            return <span style={{fontWeight:"bold"}}>{cell}</span>
        }
    }


    formatCenaCell(cell,row){
            return <div style={{fontWeight:"bold", textAlign:"right"}}>{acc.formatMoney(cell)}</div>
    }
    
    render() {
        const options = {
            noDataText: 'Brak pasujących rekordów',
        };


        return (
            <div style={{borderBottom:"3px solid #ddd", padding: "15px 0", marginTop: "10px"}}>
                <h3 style={{textAlign:"center", marginTop:0, marginBottom:0}}>
                    Raport dopłaty OGÓŁEM
                </h3>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='nazwaulgi' isKey
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.formatCell}
                        >Nazwa ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='proculgi'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.formatCell}
                        >% ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.formatCell}
                        >Ilość</TableHeaderColumn>
                        <TableHeaderColumn dataField='status'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCell}
                        >Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartdoplbrutto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. dopłaty brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartdoplnetto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. dopłaty netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartdoplvat'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. dopłaty VAT</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartbilbrutto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. biletu brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartbilnetto'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. biletu netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartbilvat'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCenaCell}
                        >Wart. biletu VAT</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/RaportDoplatGrup/components/UrzadRaportDoplatGrupOgolemTable.js